import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aa45983"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Új szálláskérések", -1))
const _hoisted_3 = { class: "text-h3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Elküldött ajánlatok", -1))
const _hoisted_5 = { class: "text-h3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Foglalásra váró ajánlatok", -1))
const _hoisted_7 = { class: "text-h3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Aktív foglalások", -1))
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "text-h3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Lejárt számlák", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Legutóbbi szálláskérések", -1))
const _hoisted_13 = {
  class: "font-weight-bold",
  style: {"font-family":"monospace"}
}
const _hoisted_14 = { class: "text-body-2 text-medium-emphasis ml-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Közelgő érkezések", -1))
const _hoisted_16 = {
  class: "ml-2 font-weight-bold",
  style: {"font-family":"monospace"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, { class: "mb-4" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4",
                    key: n
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_skeleton_loader, {
                        type: "card",
                        height: "120"
                      })
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            }),
            _createVNode(_component_v_skeleton_loader, {
              class: "mb-4",
              type: "card",
              height: "200"
            }),
            _createVNode(_component_v_skeleton_loader, {
              class: "mb-4",
              type: "card",
              height: "200"
            })
          ], 64))
        : ($setup.error)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 1,
              class: "mb-4",
              type: "error",
              variant: "tonal"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  color: "error",
                  onClick: $setup.fetchDashboardData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Újrapróbálás")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode("Nem sikerült betölteni az adatokat.")
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_v_row, { class: "mb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "stat-card",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.navigateToInquiries('NEW'))),
                        style: {"border-left":"4px solid rgb(var(--v-theme-warning))","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, _toDisplayString($setup.newInquiriesCount), 1),
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "stat-card",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.navigateToInquiries('OFFER SENT'))),
                        style: {"border-left":"4px solid rgb(var(--v-theme-info))","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, _toDisplayString($setup.offersSentCount), 1),
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "stat-card",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.navigateToInquiries('OFFER ACCEPTED'))),
                        style: {"border-left":"4px solid rgb(var(--v-theme-primary))","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, _toDisplayString($setup.acceptedOffersCount), 1),
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "stat-card",
                        onClick: $setup.navigateToBookings,
                        style: {"border-left":"4px solid rgb(var(--v-theme-success))","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, _toDisplayString($setup.activeBookingsCount), 1),
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "stat-card",
                        onClick: $setup.navigateToBills,
                        style: {"border-left":"4px solid rgb(var(--v-theme-error))","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString($setup.overdueBillsCount), 1),
                                ($setup.overdueBillsCount > 0)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: "ml-2",
                                      color: "error",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-alert-circle")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                color: "primary",
                                size: "small",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.navigateToInquiries()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Összes →")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          ($setup.latestInquiries.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.latestInquiries, (inquiry) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: inquiry.id,
                                      onClick: ($event: any) => ($setup.navigateToInquiryDetails(inquiry.id)),
                                      style: {"cursor":"pointer"}
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_chip, {
                                          class: "mr-3",
                                          color: $setup.statusColor(inquiry.status),
                                          size: "small",
                                          variant: "tonal"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.inquiryStatusLabel(inquiry.status)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_13, _toDisplayString($setup.formatPublicReference(inquiry.publicReference)), 1),
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(inquiry.companyName), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(inquiry.area) + " · " + _toDisplayString(inquiry.from) + " – " + _toDisplayString(inquiry.to), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_alert, {
                                    type: "info",
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Nincs szálláskérés.")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                            default: _withCtx(() => [
                              _hoisted_15,
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                color: "primary",
                                size: "small",
                                onClick: $setup.navigateToBookings
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Összes →")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          ($setup.upcomingCheckIns.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upcomingCheckIns, (checkIn) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: checkIn.publicReference + checkIn.startDate,
                                      onClick: ($event: any) => ($setup.navigateToBookingDetails(checkIn.publicReference)),
                                      style: {"cursor":"pointer"},
                                      "prepend-icon": "mdi-domain"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(checkIn.accommodation), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Érkezés: " + _toDisplayString(checkIn.startDate) + " · " + _toDisplayString(checkIn.guestCount) + " fő", 1),
                                            _createElementVNode("span", _hoisted_16, _toDisplayString($setup.formatPublicReference(checkIn.publicReference)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_alert, {
                                    type: "info",
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Nincs közelgő érkezés a következő 7 napban.")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
    ]),
    _: 1
  }))
}